/* eslint-disable react/no-danger */
/* eslint-disable react/no-multi-comp */
import React from "react"
import Img from "gatsby-image/withIEPolyfill"
import { CTA, Headline, Eyebrow, GridLines } from "@shared"
import { css } from "@jsUtils"
import { CONTENT } from "@data"

import { PageSection } from "../PageSection"

import Styles from "./careers.module.scss"

const { CAREERS } = CONTENT
const { HEADER } = CAREERS
const { eyebrow, cta } = HEADER
/**
 * Careers Section
 * @param {object} props - React props
 */
const OurPeople = props => {
  const { color, theme, photos, headline, headerCopy, gridHeadline, gridCopy } = props
  const [ready, setReady] = React.useState(false)

  return (
    <PageSection
      className={css(Styles.section, Styles[`theme_${theme}`], ready && Styles.ready)}
      theme={theme}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <GridLines theme={theme} />
      <div className={Styles.content}>
        <div className={Styles.leftHalf}>
          <div className={Styles.copy}>
            <Eyebrow className={Styles.eyebrow} color={color}>
              {eyebrow}
            </Eyebrow>
            <Headline className={Styles.headline} size={2}>
              {headline}
            </Headline>
            <div className={Styles.description} dangerouslySetInnerHTML={{ __html: headerCopy }} />
            <CTA
              ascope="CTAS"
              adata="MISC.JOINUS"
              ready={ready}
              className={Styles.cta}
              to="https://boards.greenhouse.io/exo"
              // to="https://www.linkedin.com/company/exoeffect/jobs/"
              color={color}
              target="_blank"
              rel="noopener noreferrer"
              anchor
            >
              {cta}
            </CTA>
            {/* <CTA
              ascope="CTAS"
              adata="MISC.JOINUS"
              ready={ready}
              className={Styles.cta2}
              to="/open-positions/"
              color={color}
              target="_blank"
              rel="noopener noreferrer"
              anchor
            >
              Open Positions
            </CTA> */}
          </div>
          <div className={Styles.featuredPerson}>
            <div className={Styles.photoWrapper}>
              <Img alt={photos[0].title} className={Styles.photo} fluid={photos[0].fluid} />
            </div>
          </div>
        </div>
        <div className={Styles.rightHalf}>
          <div className={Styles.leftQuarter}>
            <div className={Styles.photoWrapper}>
              <Img alt={photos[1].title} className={Styles.photo} fluid={photos[1].fluid} />
            </div>
          </div>
          <div className={Styles.rightQuarter}>
            <div className={Styles.photoWrapper}>
              <Img alt={photos[2].title} className={Styles.photo} fluid={photos[2].fluid} />
            </div>
            <div className={Styles.spacer} />
            <div className={Styles.photoWrapper}>
              <Img alt={photos[3].title} className={Styles.photo} fluid={photos[3].fluid} />
            </div>
          </div>
        </div>
      </div>
      <div className={Styles.gridCopy}>
        <Headline className={Styles.gridHeadline} size={3}>
          {gridHeadline}
        </Headline>
        <div className={Styles.gridDescription} dangerouslySetInnerHTML={{ __html: gridCopy }} />
      </div>
    </PageSection>
  )
}

export default OurPeople
